// extracted by mini-css-extract-plugin
export default {"accordion-item":"indexAr_accordion-item__Hy3HH","header":"indexAr_header__fyPP5","body":"indexAr_body__1fFRw","learn_more":"indexAr_learn_more__+QFMo"};